import { extendTheme } from "@chakra-ui/react";
import "@fontsource/open-sans";
import "@fontsource/raleway";


export const color = {
  primary: "#0773BB",
  secondary: "#ffffff",
  teritary: "#F4F5F7",
  text: "#353935",
};


const chakratheme = extendTheme({
  fonts: {
    heading: `'Open Sans', sans-serif`,
    body: `'Raleway', sans-serif`,
  },
});

export default chakratheme;
